<script>
import { createScrollManager } from './scrollmanager';

export default {
  name: 'ScrollingController',

  props: {
    el: {
      type: HTMLElement,
      default: undefined,
    },

    virtualScrolling: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      scrollPosition: 0,
      scrollManager: null,
    };
  },

  mounted() {
    this.scrollManager = createScrollManager(this.el || window);
    this.scrollManager.add(this.updateScrollposition);

    this.$once('hook:beforeDestroy', () => {
      this.scrollManager.destroy();
    });
  },

  methods: {
    updateScrollposition(scrollPosition) {
      const headerHeight = document.documentElement.clientHeight - window.innerHeight;
      const vh = Math.min(document.documentElement.clientHeight, window.innerHeight);
      this.scrollPosition = scrollPosition / (vh + headerHeight);
    },
  },

  render() {
    return this.$scopedSlots.default({
      scrollPosition: this.scrollPosition,
    });
  },
};
</script>
